<div class="lp-infinite-scroll-trigger">
  @if (isLoading()) {
    <div class="dm-padding-vertical-24 dm-display-flex dm-justify-content-center">
      <dm-loading-indicator type="line-simple" size="md" label="Wird geladen…" i18n-label="@@common.loading" />
    </div>
  }
</div>
